const state = {
  menus: {
    transaksi : {
      name : "Rekap Transaksi",
      items: [
        {
          name : "Transaksi Reguler",
          linkTo: "TransaksiGlobal"
        },
        {
          name : "Transaksi Self Service",
          linkTo: "TransaksiSnapcleanGlobal"
        },
        {
          name : "Top Up Deposit",
          linkTo: "TopupDeposit"
        },
        {
          name : "Top Up E-Payment",
          linkTo: "TopupEpayment"
        },
        {
          name : "Pesanan Dari Loyalty Apps",
          linkTo: "order_in_loyalty/list",
          isWebview: true,
          isWhitelabel: true,
        },
      ]
    },
    penghapusan : {
      name : "Penghapusan",
      items: [
        {
          name : "Penghapusan Transaksi Reguler",
          linkTo: "PembatalanTransaksiReguler.list"
        },
        {
          name : "Penghapusan Transaksi Self Service",
          linkTo: "PembatalanTransaksiSnapclean.list"
        },
        {
          name : "Penghapusan Top Up Deposit",
          linkTo: "PembatalanTopupDeposit.list"
        },
        {
          name : "Penghapusan Top Up E-Payment",
          linkTo: "PembatalanTopupEpayment.list"
        },
        {
          name : "Penghapusan Transaksi Loyalti",
          linkTo: "loyalti-transaction/delete",
          isWebview: true,
          isWhitelabel: true,
        },
      ]
    }
  }
}

export default state;